import { render } from "./bigSearch.vue?vue&type=template&id=58be25bd&scoped=true"
import script from "./bigSearch.vue?vue&type=script&lang=js"
export * from "./bigSearch.vue?vue&type=script&lang=js"

import "./bigSearch.vue?vue&type=style&index=0&id=58be25bd&scoped=true&lang=scss"
import "./bigSearch.vue?vue&type=style&index=1&id=58be25bd&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58be25bd"]])

export default __exports__